import { CardItemContainer, SkeletonBox } from '@presentation/components';
import type { FC } from 'react';

export const PageSkeleton: FC = () => {
  return (
    <CardItemContainer>
      {Array(3)
        .fill(undefined)
        .map((_, index) => (
          <SkeletonBox
            key={`${index}-loading-skeleton`}
            style={{ width: '100%', height: index === 0 ? '170px' : '46px', margin: '10px auto' }}
          />
        ))}
    </CardItemContainer>
  );
};
